import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { generateAvatarLinkFromHash, generateBannerLinkFromHash } from 'src/utils/linkUtils';
import { textLight, titleLarge } from 'styles-js/mixins/typography';
import { BannerWrapper, BannerContainer, AvatarWrapper, AvatarContainer } from 'src/modules/user/profile/components/shared/sharedStyles';
import ButtonsPanel from 'src/modules/user/profile/components/profileButtonsPanel';
import Separator from 'src/components/separator';
export default function ProfileHeader() {
  const {
    profileUser,
    basics
  } = useSelector(({
    pages
  }) => pages.profile);
  const {
    userImageHash,
    userBannerHash
  } = basics;
  const {
    isDeceased,
    totalPosts,
    totalReplies,
    username
  } = profileUser;
  return <Header data-sentry-element="Header" data-sentry-component="ProfileHeader" data-sentry-source-file="profileHeader.tsx">
      <BannerWrapper data-sentry-element="BannerWrapper" data-sentry-source-file="profileHeader.tsx">
        <BannerContainer imageUrl={generateBannerLinkFromHash(userBannerHash)} data-sentry-element="BannerContainer" data-sentry-source-file="profileHeader.tsx" />
      </BannerWrapper>
      <ContentWrapper data-sentry-element="ContentWrapper" data-sentry-source-file="profileHeader.tsx">
        <AvatarWrapper data-sentry-element="AvatarWrapper" data-sentry-source-file="profileHeader.tsx">
          <AvatarContainer imageUrl={generateAvatarLinkFromHash(userImageHash)} data-sentry-element="AvatarContainer" data-sentry-source-file="profileHeader.tsx" />
        </AvatarWrapper>
        <TextWrapper data-sentry-element="TextWrapper" data-sentry-source-file="profileHeader.tsx">
          <Title data-sentry-element="Title" data-sentry-source-file="profileHeader.tsx">
            {isDeceased && <Remembering>{i18n.t('Remembering')}</Remembering>}
            {username}
          </Title>
          <StatsPanel data-sentry-element="StatsPanel" data-sentry-source-file="profileHeader.tsx">
            <span data-testid="profile__stats_posts">{totalPosts}</span>{' '}{i18n.t('Posts')}
            <StyledSeparator data-sentry-element="StyledSeparator" data-sentry-source-file="profileHeader.tsx" />
            <span data-testid="profile__stats_replies">{totalReplies}</span>{' '}{i18n.t('Replies')}
          </StatsPanel>
        </TextWrapper>
        <ButtonsPanel data-sentry-element="ButtonsPanel" data-sentry-source-file="profileHeader.tsx" />
      </ContentWrapper>
    </Header>;
}
const Header = styled.div`
  width: 100%;
  margin: 0 0 25px;
  border: ${({
  theme
}) => theme.greyLine};
  @media (${({
  theme
}) => theme.underScreenSmall}) {
    border: 0;
    margin: 0;
    text-align: center;
  }
`;
const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 10px 15px 15px 0;
  @media (${({
  theme
}) => theme.underScreenSmall}) {
    flex-direction: column;
    padding: 15px;
  }
`;
const TextWrapper = styled.div`
  margin-left: 160px;
  @media (${({
  theme
}) => theme.underScreenSmall}) {
    margin-left: 0;
    text-align: center;
  }
`;
const Title = styled.div`
  ${titleLarge};
  @media (${({
  theme
}) => theme.underScreenSmall}) {
    margin: 5px 0;
  }
`;
const Remembering = styled.div`
  ${textLight};
  font-style: italic;
`;
const StatsPanel = styled.div`
  ${textLight};
  @media (${({
  theme
}) => theme.underScreenSmall}) {
    margin: 5px 0;
  }
`;
const StyledSeparator = styled(Separator)`
  margin: 0 8px;
`;